// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5bfbc68950e459d3879e","263":"1ca45bd35ae1aab293eb","264":"69d29fa64725e4ec6b39","317":"f2799298bb8fb58c20b9"}[chunkId] + ".chunk.js";
};